import { CSSProperties, FC, HTMLProps } from 'react';

import { Interpolation } from '@emotion/react';

import { styled } from '../theme';

type Props = HTMLProps<HTMLDivElement> & {
    className?: string;
    css?: Interpolation;
    /* @description will add spacing between children, work depending on row/column layout */
    itemsSpacing?: number;
    direction?: CSSProperties['flexDirection'];
    wrap?: CSSProperties['flexWrap'];
    justify?: CSSProperties['justifyContent'];
    align?: CSSProperties['alignItems'];
    grow?: CSSProperties['flexGrow'];
    shrink?: CSSProperties['flexShrink'];
    basis?: CSSProperties['flexBasis'];
    gap?: CSSProperties['gap'];
};

const FlexBox = styled.div<Props>(
    ({
        itemsSpacing,
        direction: flexDirection,
        justify: justifyContent,
        wrap: flexWrap,
        align: alignItems,
        grow: flexGrow,
        shrink: flexShrink,
        basis: flexBasis = 'auto',
        gap,
    }) => ({
        display: 'flex',
        ...(itemsSpacing != null && {
            '> * + *': {
                [flexDirection === 'row' ? 'marginLeft' : 'marginTop']: itemsSpacing,
            },
        }),
        flexDirection,
        flexWrap,
        justifyContent,
        alignItems,
        flexGrow,
        flexShrink,
        flexBasis,
        gap,
    })
);

export default FlexBox as unknown as FC<Props>;
